"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourFuture() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reassurances = ["Complimentary 15-min consultation", "Confidential & private", "Same-week availability"];
  return <section data-section-id="4198" id="secure-your-future" className="bg-background text-foreground relative overflow-hidden py-32 md:py-48 px-6">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <svg viewBox="0 0 1600 200" preserveAspectRatio="xMidYMid meet" className={`w-[140%] max-w-none transition-all duration-[2000ms] ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`} style={{
        color: "var(--primary)"
      }}>
          <path d="M0 100 L300 100 L340 100 L360 60 L390 140 L420 40 L450 160 L480 100 L700 100 L740 100 L760 70 L790 130 L820 50 L850 150 L880 100 L1100 100 L1140 100 L1160 65 L1190 135 L1220 45 L1250 155 L1280 100 L1600 100" fill="none" stroke="currentColor" strokeWidth="2" strokeOpacity="0.08" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <div ref={sectionRef} className="relative mx-auto max-w-[960px] flex flex-col items-center text-center">
        {}
        <div className={`flex items-center gap-3 mb-10 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="h-px w-8 bg-foreground/40" aria-hidden="true" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
            Initiate
          </span>
        </div>

        {}
        <h2 className={`font-default font-light tracking-tight text-foreground text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[7.5rem] leading-[1.02] mb-12 md:mb-16 transition-all duration-1000 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          Your legacy begins with{" "}
          <span className="italic text-primary font-normal">a strategic dialogue</span>
          .
        </h2>

        {}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 mb-14 md:mb-16 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Button asChild className="h-16 px-10 text-base font-default tracking-wide bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg group">
            <Link to="/ContactPage">
              <span>Schedule Your Consultation</span>
              <ArrowRight className="size-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>

        {}
        <div className={`w-full max-w-md transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-50"}`}>
          <Separator className="bg-border/40" />
        </div>

        {}
        <ul className={`mt-10 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-3 font-sans text-[13px] text-muted-foreground transition-all duration-1000 delay-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {reassurances.map((item, i) => <li data-index={i} className="flex items-center gap-2">
              <span className="text-primary" aria-hidden="true">
                
              </span>
              <span className="tracking-wide">{item}</span>
              {i < reassurances.length - 1 && <span className="hidden sm:inline text-muted-foreground/40 ml-6" aria-hidden="true">
                  ·
                </span>}
            </li>)}
        </ul>
      </div>
    </section>;
}